import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PosService } from "src/app/core/services/pos.service";
import { CheckItemDto } from "src/app/shared/models/check-dto";

@Component({
	selector: "app-pos-on-screen-check-items",
	templateUrl: "./pos-on-screen-check-items.component.html",
	styleUrls: ["./../../../pos.scss"],
})
export class PosOnScreenCheckItemsComponent implements OnInit {
	@Input() checkItem: CheckItemDto;
	@Output() checkItemChange = new EventEmitter<CheckItemDto>();

	@Input() selectedItem: CheckItemDto;
	@Output() selectedItemChange = new EventEmitter<CheckItemDto>();

	itemSelected: boolean = false;

	constructor(posService: PosService) {}

	ngOnInit(): void {}
}
